interface EventTypeAttributes {
  guestHeadingPrefix: string
  guestLabel: string
  forceLayout?: string
}

const ATTRIBUTES_BY_EVENT_TYPE: Record<string, EventTypeAttributes | undefined> = {
  Party: { guestHeadingPrefix: 'Woohoo! 🕺💃', guestLabel: 'party people' },
  'Private Dining': {
    guestHeadingPrefix: 'Delicious! 🍽',
    guestLabel: 'diners',
    forceLayout: 'seating',
  },
  'Meeting/Workshop': {
    guestHeadingPrefix: 'Splendid! 💼',
    guestLabel: 'attendees',
    forceLayout: 'seating',
  },
  'Team Activity': { guestHeadingPrefix: 'Sounds like fun! 🎉', guestLabel: 'participants' },
  Presentation: { guestHeadingPrefix: 'Exciting! 🎤', guestLabel: 'attendees' },
  Wedding: { guestHeadingPrefix: 'Congratulations! 💐', guestLabel: 'guests' },
  Networking: { guestHeadingPrefix: 'Terrific! 🤝', guestLabel: 'guests' },
  Studio: { guestHeadingPrefix: 'Awesome! 📸 🎧', guestLabel: 'superstars' },
  Conference: { guestHeadingPrefix: 'Excellent! 🎤', guestLabel: 'attendees' },
  'Something Else': { guestHeadingPrefix: 'Marvelous! ✨', guestLabel: 'guests' },
}

export default ATTRIBUTES_BY_EVENT_TYPE
